import React from "react";
import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
import RaisedButton from 'material-ui/RaisedButton';
import PropTypes from "prop-types";
import ReactQuill from "react-quill";
import isMobile from "is-mobile";
import "./MarkDialog.css";

export default class MarkDialog extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            dialogProps: {
                open:false
            }
        };

    }

    showHandler(){
        this.props.onSubmit({
            msg:this.state.dialogProps.msg,
            status:this.state.dialogProps.status+1,
            key:this.state.dialogProps.key,
            userKey:this.state.dialogProps.userKey
        });
    }

    notShowHandler(){
        this.props.onSubmit({
            msg:this.state.dialogProps.msg,
            status:Math.max(this.state.dialogProps.status-1, 0),
            key:this.state.dialogProps.key,
            userKey:this.state.dialogProps.userKey
        });
    }

    saveHandler(){
        this.props.onSubmit({
            msg:this.state.dialogProps.msg,
            status:this.state.dialogProps.status,
            key:this.state.dialogProps.key,
            userKey:this.state.dialogProps.userKey
        });
    }

    cancelHandler(){
        this.props.onSubmit({
            msg:this.props.dialogProps.msg,
            status:this.props.dialogProps.status,
            key:this.props.dialogProps.key,
            userKey:this.props.dialogProps.userKey
        });
    }

    componentDidMount(){
        // this.quill.blur();
    }

    componentWillReceiveProps(newProps) {
        this.setState({dialogProps:newProps.dialogProps});
    }

    render() {
        const actions = [
            <FlatButton
                label={`봤어요`}
                primary={true}
                onTouchTap={this.showHandler.bind(this)}
            />,
            <FlatButton
                label="안봤어요"
                onTouchTap={this.notShowHandler.bind(this)}
            />,
            <span className="MarkDialogButtonSperator" style={{borderLeftWidth:1,borderLeftStyle:'solid',borderLeftColor:'#ececec', marginLeft:10, marginRight:10}}></span>,
            <FlatButton
                label={`저장`}
                onTouchTap={this.saveHandler.bind(this)}
            />
        ];
        if(!isMobile()){
            actions.push(<FlatButton
                label="취소"
                onTouchTap={this.props.onCloseRequest}
            />);
        }
        var _toolbar = isMobile() ? [
            [{ 'header': [1, 2, false] }],
            ['underline'],
            [{'list': 'bullet'}],
            ['link']
        ] : [
            [{ 'header': [1, 2, false] }],
            ['bold', 'underline', 'strike', 'blockquote'],
            [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
            ['link'],
            ['clean']
        ]
        return (
            <Dialog
                bodyClassName={"MarkDialogBody"}
                className="MarkDialogComponent"
                actions={actions}
                modal={false}
                open={this.state.dialogProps.open}
                onRequestClose={this.props.onCloseRequest}
                autoScrollBodyContent={true}
                repositionOnUpdate={true}
                contentStyle={{width:'95%', maxWidth:640}}
            >
                <ReactQuill
                    selection={{start:0, end:0}}
                    value={this.state.dialogProps.msg}
                    modules={
                        {
                            toolbar: _toolbar
                        }
                    }
                    theme="snow"
                    ref="bodyInput"
                    onChange={function(v){
                        let s = Object.assign({}, this.state);
                        s.dialogProps.msg = v
                        this.setState(s);
                    }.bind(this)} /><br />
               {/* <TextField
                    autoFocus
                    floatingLabelText="한마디 해주세요"
                    floatingLabelFixed={true}
                    multiLine={true}
                    rows={20}
                    fullWidth={true}
                    defaultValue={this.props.dialogProps.msg}
                    value={this.state.dialogProps.v}
                    onChange={function(event){
                        let v = event.target.value;
                        let s = Object.assign({}, this.state);
                        s.dialogProps.msg = v
                        this.setState(s);
                    }.bind(this)}
                /><br />*/}
            </Dialog>
        );
    }
}
MarkDialog.propTypes = {
    dialogProps:PropTypes.object.isRequired,
    onSubmit:PropTypes.func.isRequired
}


// WEBPACK FOOTER //
// ./src/container/campaign/component/MarkDialog.js